import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDialogAPI } from "../dialogs/context/DialogProvider";
import { MapPath } from "../map/Map";
import { useScoreData } from "../score/context/ScoreProvider";
import { UseScormAPI } from "../scorm/context/ScormAPIProvider";
import { useSfxAPI } from "../sfx/context/SfxProvider";

/**TO REFACTO : must be a context provider for code consistency purpose */
const EventsModule = () => {
  console.info("EventModule render");

  //  OTHER CONTEXTS
  const location = useLocation();
  const navigate = useNavigate();
  const { startNewDialogSequence } = useDialogAPI();
  const { progression } = useScoreData();
  const { completeSCO } = UseScormAPI();
  const { chapters } = useScoreData();
  const { loop } = useSfxAPI();
  const [clicked, setClicked] = useState(false);

  //  LOGIC
  //  on progression change
  useEffect(() => {
    //  end of the module
    if (progression === 1) {
      completeSCO();

      setTimeout(function () {
        // navigate(`/`)
        startNewDialogSequence("main.conclusion", chapters);
      }, 1500);
    }
  }, [progression, completeSCO]);

  useEffect(() => {
    const handleClick = () => {
      if (clicked) return;
      loop("loop");
      setClicked(true);
    };

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [clicked]);

  //  on location change
  useEffect(() => {
    switch (location.pathname as MapPath) {
      case "/":
        startNewDialogSequence("main.intro", chapters);
        break;
      case "/engin":
        startNewDialogSequence("engin.intro", chapters);
        break;
      case "/exchange":
        startNewDialogSequence("exchange.intro", chapters);
        break;
      case "/labo":
        startNewDialogSequence("labo.intro", chapters);
        break;
    }
  }, [location.pathname, startNewDialogSequence, chapters]);

  return <></>;
};

export default EventsModule;
